import "../style/page/ProductOrderpage.scss";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  productorder,
  productorderid,
  sidebar,
} from "../redux/reducer/counterslice";
import { useEffect, useState, useMemo } from "react";
import { diagnosticsorder, diagnostictracksorder } from "../../text/apidata";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NavLink } from "react-router-dom";
import noimage1 from "../../assets/images/noimage.png";
// import ProductOrderForm from "../form/productorderform";
import DiagnosticsOrderForm from "../form/Diagnosticsorderform";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { Chart } from "react-google-charts";
import FileSaver from "file-saver";
import XLSX from "sheetjs-style";

function DiagnosticsOrder(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const dispatch = useDispatch();
  const dispatchid = useDispatch();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const productstate = useSelector((state) => state.counter.productorder);
  const productid = useSelector((state) => state.counter.productorderid);
  const [trackorderid, settrackorderid] = useState("");
  const [trackorderstate, settrackorderstate] = useState(false);
  const [trackorderdata, settrackorderdata] = useState([]);
  const [timeString, settimeString] = useState("");
  const locationid = useSelector(
    (state) => state.counter.loginuser_location_id
  );
  const [branches, setbranches] = useState(
    locationid != "all" ? locationid : "91"
  );

  var today = new Date();
  // var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);
  const [range, setrange] = useState([gt, it]);
  const [diagStatus, setDiagStatus] = useState("all");
  const [pieChartData, setPieChartData] = useState({
    confirming_order: 2,
    confirm_the_details: 4,
    en_route: 2,
    samples_collected: 2,
  });
  // for pie chart
  const pie_chart_data = [
    ["Diagnostics", "count"],
    ["Confirming order", pieChartData.confirming_order],
    ["Confirm the details", pieChartData.confirm_the_details],
    ["En route", pieChartData.en_route],
    ["Samples Collected", pieChartData.samples_collected],
  ];
  const options = {
    title: "Diagnostics order status",
    pieHole: 0.5,
    is3D: false,
    slices: {
      //   0: { color: "lite-blue" },
      1: { color: "grey" },
      3: { color: "green" },
    },
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const cleaningrange = () => {
    //setrange([gt,it]);
  };
  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        axios({
          method: "get",
          url: diagnosticsorder,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            date_gt: range[0],
            date_lt: range[1],
            status: diagStatus,
            order_list: "true",
            branch: branches,
          },
        })
          .then((res) => {
            let diagnostics_status = {
              confirming_order: res.data.data.data.confirming_order,
              confirm_the_details: res.data.data.data.confirm_the_details,
              en_route: res.data.data.data.en_route,
              samples_collected: res.data.data.data.samples_collected,
            };
            setPieChartData(diagnostics_status);
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      axios({
        method: "get",
        url: diagnosticsorder,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          date_gt: range[0],
          date_lt: range[1],
          status: diagStatus,
          order_list: "true",
          branch: branches,
        },
      })
        .then((res) => {
          let diagnostics_status = {
            confirming_order: res.data.data.confirming_order,
            confirm_the_details: res.data.data.confirm_the_details,
            en_route: res.data.data.en_route,
            samples_collected: res.data.data.samples_collected,
          };
          // let diagnostics_status= {
          //   confirming_order: 3,
          //   confirm_the_details: 4,
          //   en_route:6,
          //   samples_collected: 9,
          // }
          setPieChartData(diagnostics_status);
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [
    dtpageindex,
    dtpagesize,
    searchQuery,
    productstate,
    range,
    diagStatus,
    branches,
  ]);
  useEffect(() => {
    if (trackorderid != "") {
      axios({
        method: "get",
        url: diagnostictracksorder + trackorderid + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          settrackorderdata(res.data.data);
          var dateTimeString = res.data.data.order.created_date;

          // Create a Date object from the string
          var dateTime = new Date(dateTimeString);

          // Extract hours, minutes, and seconds
          var hours = dateTime.getHours();
          var minutes = dateTime.getMinutes();
          var seconds = dateTime.getSeconds();

          // Format the time as a string
          settimeString(hours + ":" + minutes + ":" + seconds);

          console.log(res);
        })
        .catch((error) => {});
    }
  }, [trackorderid]);

  const dropdownhandlechange = (id, e) => {
    dispatchid(productorderid(id));
    dispatch(productorder("Edit"));
  };

  const columns = useMemo(
    () => [
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  disabled={
                    row.row.original.razorpay_diagnostics != null
                      ? row.row.original.razorpay_diagnostics.isPaid == false
                        ? true
                        : false
                      : row.row.original.fully_used == false
                      ? true
                      : false
                  }
                  onClick={(e) => {
                    dropdownhandlechange(row.row.original.id, e);
                    e.stopPropagation();
                  }}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
              </div>
            </>
          );
        },
      },
      {
        Header: "Bill Id",
        accessor: "",

        Cell: (row) => {
          var final_dia_id = "--";
          if (row.row.original.razorpay_diagnostics != null) {
            if (row.row.original.razorpay_diagnostics.isPaid == true) {
              final_dia_id = String(row.row.original.id).slice(-12);
            }
          } else if (row.row.original.fully_used == true) {
            final_dia_id = String(row.row.original.id).slice(-12);
          }
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={final_dia_id}
              >
                {final_dia_id}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(String(final_dia_id));
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Wallet Id",
        accessor: "",

        Cell: (row) => {
          var final_walet_dia__id = "--";
          if (row.row.original.razorpay_diagnostics != null) {
            if (row.row.original.razorpay_diagnostics.isPaid == true) {
              if (row.row.original.wallet_id == null) {
                final_walet_dia__id = "--";
              } else {
                final_walet_dia__id = row.row.original.wallet_id;
              }
            }
          } else if (row.row.original.fully_used == true) {
            if (row.row.original.wallet_id == null) {
              final_walet_dia__id = "--";
            } else {
              final_walet_dia__id = row.row.original.wallet_id;
            }
          }

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={final_walet_dia__id}
              >
                {final_walet_dia__id}
              </p>
              {/* <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(row.row.original.wallet_id);
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button> */}
            </>
          );
        },
      },

      {
        Header: "Created date",
        accessor: "",

        Cell: (row) => {
          const dateString = row.row.original.created_date;
          const dateObject = new Date(dateString);

          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

          const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${formattedTime}`}
              >
                {`${
                  row.row.original.created_date.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </p>
            </>
          );
        },
      },

      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                {row.row.original.patient.first_name +
                  " " +
                  row.row.original.patient.last_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "Patient Ph.No",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.phonenumber}
              >
                {String(row.row.original.patient.phonenumber)}
              </p>
            </>
          );
        },
      },
      {
        Header: "UHID",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.p_uhid}
              >
                {row.row.original.patient.p_uhid}
              </p>
            </>
          );
        },
      },

      {
        Header: "Initial Wallet ",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.previous_cashbackpoints}
              >
                <span id="prefix">₹</span>
                {row.row.original.previous_cashbackpoints == null
                  ? "0"
                  : parseFloat(
                      row.row.original.previous_cashbackpoints
                    ).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Wallet amount Used",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.used_cashbackpoints}
              >
                <span id="prefix">₹</span>
                {row.row.original.used_cashbackpoints == null
                  ? "0"
                  : parseFloat(row.row.original.used_cashbackpoints).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Assigned By",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.assigned_by == null
                    ? "--"
                    : row.row.original.assigned_by
                }
              >
                {row.row.original.assigned_by == null
                  ? "--"
                  : row.row.original.assigned_by}
              </p>
            </>
          );
        },
      },
      {
        Header: "Assigned To",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.assigned_to == null
                    ? "--"
                    : row.row.original.assigned_to
                }
              >
                {row.row.original.assigned_to == null
                  ? "--"
                  : row.row.original.assigned_to}
              </p>
            </>
          );
        },
      },
      {
        Header: "Delivery Ph.No",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.phone_number}
              >
                {String(row.row.original.phone_number)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "",
        Cell: (row) => {
          let data = row.row.original.status;
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                className={
                  data == "Confirming order"
                    ? "ordered"
                    : data == "Confirm the details"
                    ? "confirm"
                    : data == "En route"
                    ? "enroute"
                    : data == "Samples Collected"
                    ? "done"
                    : ""
                }
                data-tooltip-content={data}
              >
                {data}
              </p>
            </>
          );
        },
      },
      {
        Header: "Total Amount",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.total_amount}
              >
                {parseFloat(row.row.original.total_amount).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.razorpay_diagnostics != null ? (
                <p
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    row.row.original.razorpay_diagnostics.isPaid == false
                      ? "No"
                      : "Yes"
                  }
                >
                  {row.row.original.razorpay_diagnostics.isPaid == false ? (
                    <p style={{ color: "red", fontWeight: 700 }}>No</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                  )}
                </p>
              ) : row.row.original.fully_used == false ? (
                <p style={{ color: "red", fontWeight: 700 }}>No</p>
              ) : (
                <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
              )}
            </>
          );
        },
      },

      {
        Header: "Location Range",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.address.location_range == null
                    ? ""
                    : row.row.original.address.location_range
                }
              >
                {row.row.original.address.location_range != null
                  ? row.row.original.address.location_range + " Km"
                  : "--"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Patient Address",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.address.location_range == null
                    ? ""
                    : row.row.original.address.location_range
                }
              >
                {row.row.original.address.address_line2}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let string_convert = String(
                    row.row.original.address.address_line1 +
                      ", " +
                      row.row.original.address.address_line2 +
                      ". " +
                      row.row.original.address.latitude +
                      ", " +
                      row.row.original.address.longitude
                  );
                  let isCopy = copy(string_convert);
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Razor pay ID",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    row.row.original.razorpay_diagnostics?.diagnostic_order_id
                  )}
                >
                  {row.row.original.razorpay_diagnostics?.diagnostic_order_id ==
                  null
                    ? "--"
                    : row.row.original.razorpay_diagnostics
                        ?.diagnostic_order_id}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "VisitDate",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(row.row.original.visit_date)}
                >
                  {String(row.row.original.visit_date)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "VisitTime",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(row.row.original.visit_slot)}
                >
                  {String(row.row.original.visit_slot)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Delivery Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original?.delivery_date;
          const dateObject = new Date(dateString);

          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

          const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${formattedTime}`}
              >
                {row.row.original?.delivery_date != null
                  ? row.row.original?.delivery_date?.slice(0, 10) +
                    "  " +
                    formattedTime
                  : "--"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Return Amount",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.return_amount}
              >
                {parseFloat(row.row.original.return_amount).toFixed(2)}
              </p>
            </>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const loaderchangechild = (arg) => {
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

    {
      label: "Last week",
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value, index) => {
        // console.log(value);
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];

  const datadownload = () => {
    axios({
      method: "get",
      url: diagnosticsorder,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      params: {
        page: dtpageindex,
        page_size: datacount,
        search: searchQuery,
        date_gt: range[0],
        date_lt: range[1],
        status: diagStatus,
        order_list: "true",
        branch: branches,
      },
    })
      .then((res) => {
        var downdata = [];
        downdata = res.data.data.data.map((ele, index) => {
          var final_dia_id = "--";
          if (ele.razorpay_diagnostics != null) {
            if (ele.razorpay_diagnostics.isPaid == true) {
              final_dia_id = String(ele.id).slice(-12);
            }
          } else if (ele.fully_used == true) {
            final_dia_id = String(ele.id).slice(-12);
          }

          var final_walet_dia__id = "--";
          if (ele.razorpay_diagnostics != null) {
            if (ele.razorpay_diagnostics.isPaid == true) {
              if (ele.wallet_id == null) {
                final_walet_dia__id = "--";
              } else {
                final_walet_dia__id = ele.wallet_id;
              }
            }
          } else if (ele.fully_used == true) {
            if (ele.wallet_id == null) {
              final_walet_dia__id = "--";
            } else {
              final_walet_dia__id = ele.wallet_id;
            }
          }
          return {
            "Bill Id": final_dia_id,
            "Wallet Id": final_walet_dia__id,
            "Created date": ele.created_date,
            UHID: String(ele.appointment?.patient?.p_uhid),
            "Patient Name":
              ele.patient.first_name + " " + ele.patient.last_name,
            "Patient Ph.No": ele.patient.phonenumber,
            UHID: ele.patient.p_uhid,
            "Initial Wallet":
              ele.previous_cashbackpoints == null
                ? "0"
                : parseFloat(ele.previous_cashbackpoints).toFixed(2),
            "Wallet amount Used":
              ele.used_cashbackpoints == null
                ? "0"
                : parseFloat(ele.used_cashbackpoints).toFixed(2),
            "Assigned By": ele.assigned_by == null ? "--" : ele.assigned_by,
            "Assigned To": ele.assigned_to == null ? "--" : ele.assigned_to,
            Status: ele.status,
            "Total Amount": parseFloat(ele.total_amount).toFixed(2),
            Paid:
              ele.razorpay_diagnostics != null
                ? ele.razorpay_diagnostics.isPaid == false
                  ? "No"
                  : "Yes"
                : ele.fully_used == false
                ? "No"
                : "Yes",
            "Location Range":
              ele.address.location_range != null
                ? ele.address.location_range + " Km"
                : "--",
            "Patient Address": ele.address.address_line2,
            "Razor pay ID":
              ele.razorpay_diagnostics?.diagnostic_order_id == null
                ? "--"
                : ele.razorpay_diagnostics?.diagnostic_order_id,
            VisitDate: String(ele.visit_date),
            VisitTime: String(ele.visit_slot),
            "Delivery Date": ele?.delivery_date,
          };
        });
        console.log(downdata, "afhajj");
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8";
        const fileExtension = ".xlsx";
        const ws = XLSX.utils.json_to_sheet(downdata);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "DiagnosticsOrder" + fileExtension);

        props.loaderchange("false");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <div className={sideactive ? "productorder-sa" : "productorder"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Diagnostics Order</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Diagnostics Order</li>
              </ul>
            </div>
            <div class="col-sm-5 col-auto">
              {" "}
              <div className="datepicker_dash">
                <DateRangePicker
                  defaultValue={[
                    // new Date(new Date().setDate(today.getDate() - 30)),
                    new Date(),
                    new Date(),
                  ]}
                  // disabledDate={(date) => isAfter(date, new Date())}
                  editable={false}
                  appearance="default"
                  placement="bottomEnd"
                  size="lg"
                  ranges={predefinedBottomRanges}
                  placeholder="From - To"
                  style={{ width: 270, padding: 10, float: "right" }}
                  onClean={(e) => cleaningrange(e)}
                  onChange={(e) => {
                    if (e != null) {
                      setrange([]);
                      e.forEach((newValue) => {
                        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                        var localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate("validtill", localISOTime);
                      });
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="pie_chart"
                style={{
                  justifyContent: "space-between",
                  padding: "10px",
                  display: "flex",
                }}
              >
                <Chart
                  chartType="PieChart"
                  data={pie_chart_data}
                  options={options}
                  width={"400px"}
                  height={"250px"}
                />
                <div align="center" type="button">
                  <a
                    class="dnbtn"
                    onClick={(e) => {
                      datadownload();
                    }}
                  ></a>
                </div>
              </div>
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form
                  onSubmit={handleSubmit}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      class="input-group rounded mr-2 "
                      style={{ width: "250px", height: "40px" }}
                    >
                      <select
                        class="form-select"
                        value={diagStatus}
                        name="status"
                        onChange={(e) => {
                          setDiagStatus(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          Filter By Status...
                        </option>
                        <option value={"all"}>All</option>
                        <option value={"Confirming order"}>
                          Confirming order
                        </option>
                        <option value={"Confirm the details"}>
                          Confirm the details
                        </option>
                        <option value={"En route"}>En route</option>
                        <option value={"Samples Collected"}>
                          Samples Collected
                        </option>
                      </select>
                    </div>
                  </div>
                </form>

                <div className="table-responsive">
                  <div className="custom_color_dia">
                    <BasicTable
                      columns={columns}
                      data={tableheaderdata}
                      pagesize={pagesize}
                      pageindex={pageindex}
                      dtpagesize={dtpagesize}
                      dtpageindex={dtpageindex}
                      datacount={datacount}
                      stateid={"0"}
                      settrackorderid={settrackorderid}
                      settrackorderstate={settrackorderstate}
                      location={"others"}
                      setbranches={setbranches}
                      branches={branches}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {productstate == "Edit" ? (
        <DiagnosticsOrderForm
          loaderchange={loaderchangechild}
          popupalert={popupalertchild}
          popuptext={popuptextchild}
        />
      ) : (
        ""
      )}
      {trackorderstate == true &&
        trackorderdata != undefined &&
        trackorderdata != null &&
        trackorderdata != "" && (
          <>
            <div className="card_parent">
              <div className="card22">
                <span
                  className="cross"
                  onClick={(e) => {
                    settrackorderstate(false);
                    settrackorderid("");
                  }}
                >
                  {" "}
                  <div className="title">Track Order Status</div>
                  <i class="bi bi-x-lg x"></i>
                </span>

                <div className="info">
                  <div className="row">
                    <div className="col-7">
                      <span id="heading"> Ordered Date</span>
                      <br />
                      <span id="details">
                        {trackorderdata.order.created_date != null
                          ? trackorderdata.order.created_date.slice(0, 10) +
                            "  " +
                            timeString
                          : ""}
                      </span>
                    </div>
                    <div className="col-5 pull-right">
                      <span id="heading">Delivery Date</span>
                      <br />
                      <span id="details">
                        {trackorderdata.order.delivery_date != null
                          ? trackorderdata.order.delivery_date.slice(0, 10)
                          : ""}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="tracking">
                  <div className="title">Tracking Order</div>
                </div>
                <div className="progress-track">
                  <ul id="progressbar">
                    <li
                      className={`step0 ${
                        trackorderdata.order_placed != null &&
                        trackorderdata.order_placed != undefined
                          ? "active"
                          : ""
                      }`}
                      id="step1"
                    >
                      Comfirming Order<br></br>
                      <div className="time">
                        {trackorderdata.order_placed != null &&
                        trackorderdata.order_placed != undefined
                          ? trackorderdata.order_placed.time
                          : ""}
                      </div>
                    </li>
                    <li
                      className={`step0  text-center ${
                        trackorderdata.confirmation_call != null &&
                        trackorderdata.confirmation_call != undefined
                          ? "active"
                          : ""
                      }`}
                      id="step2"
                    >
                      <span style={{ marginRight: "20px" }}>
                        Confirm the Details<br></br>
                        <div className="time">
                          {trackorderdata.confirmation_call != null &&
                          trackorderdata.confirmation_call != undefined
                            ? trackorderdata.confirmation_call.time
                            : ""}
                        </div>
                      </span>
                    </li>
                    <li
                      className={`step0 text-right ${
                        trackorderdata.intransit != null &&
                        trackorderdata.intransit != undefined
                          ? "active"
                          : ""
                      }`}
                      id="step3"
                    >
                      <span style={{ marginRight: "20px" }}>
                        En Route<br></br>
                        <div className="time">
                          {trackorderdata.intransit != null &&
                          trackorderdata.intransit != undefined
                            ? trackorderdata.intransit.time
                            : ""}
                        </div>
                      </span>
                    </li>
                    <li
                      className={`step0 text-right ${
                        trackorderdata.samplecollected != null &&
                        trackorderdata.samplecollected != undefined
                          ? "active"
                          : ""
                      }`}
                      id="step4"
                    >
                      Samples Collected<br></br>
                      <div className="time">
                        {trackorderdata.samplecollected != null &&
                        trackorderdata.samplecollected != undefined
                          ? trackorderdata.samplecollected.time
                          : ""}
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="pricing">
                  {trackorderdata.order.cart_products_dia.map((ele, index) => {
                    return (
                      <div className="row">
                        <div className="col-9">
                          <span id="name">
                            {index +
                              1 +
                              ". " +
                              ele.diagnostics.portal_description +
                              "  (" +
                              ele.diagnostics.sub_category_name +
                              ")  "}
                          </span>
                        </div>
                        <div className="col-3">
                          <span id="price">{ele.diagnostics.visit_type}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {/* <div className="total">
                <div className="row">
                  <div className="col-9" />
                  <div className="col-3">
                    <big>£262.99</big>
                  </div>
                </div>
              </div> */}
              </div>
            </div>
          </>
        )}
    </>
  );
}

export default DiagnosticsOrder;
